import React from 'react'

import HomeComp from '../../components/Home/HomeComp'

const Home = () => {
  return (
    <div>

      <HomeComp />
       
    </div>
  )
}

export default Home